import { useState } from "react";
import { experimentalStyled as styled } from "@material-ui/core/styles";
import { Container, Typography, Tabs, Tab, Box } from "@material-ui/core";
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import { LoginForm } from "../components/authentication/login";
import logoBlanco from "src/assets/logo/logo_blanco.png";
import logo from "src/assets/logo/logo.png";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const SectionStyle = styled("div")(() => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#212B36",
  padding: "48px 32px",
  minHeight: "100vh",
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------

export default function Login() {
  const [activeTab, setActiveTab] = useState(0);
  const isClient = activeTab === 1;

  return (
    <RootStyle title="TAXTIC">
      <MHidden width="mdDown">
        <SectionStyle>
          <img
            src={logoBlanco}
            alt="Taxtic"
            style={{ width: 160, marginBottom: 24 }}
          />
          <Typography
            variant="subtitle1"
            style={{ color: "#919EAB", letterSpacing: 1 }}
          >
            Portal Taxtic
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "#637381", marginTop: 8 }}
          >
            Asesoría Tributaria Integral
          </Typography>
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <MHidden width="mdUp">
            <Box display="flex" justifyContent="center" mb={4}>
              <img src={logo} alt="Taxtic" style={{ width: 140 }} />
            </Box>
          </MHidden>

          <Typography variant="h4" gutterBottom>
            {isClient ? "Accede a tu portal" : "Bienvenido de vuelta"}
          </Typography>

          <Box mb={4} mt={1}>
            <Tabs
              value={activeTab}
              onChange={(_, newValue) => setActiveTab(newValue)}
              indicatorColor="primary"
              textColor="inherit"
            >
              <Tab
                label="Empleados"
                style={{
                  color: activeTab === 0 ? "#ff802e" : "#637381",
                  fontWeight: activeTab === 0 ? 700 : 400,
                }}
              />
              <Tab
                label="Clientes"
                style={{
                  color: activeTab === 1 ? "#ff802e" : "#637381",
                  fontWeight: activeTab === 1 ? 700 : 400,
                }}
              />
            </Tabs>
          </Box>

          <LoginForm isClient={isClient} />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
